import { bool, func, string } from 'prop-types'
import { Fragment } from 'react'
import Button from '../../Button'
import { kuiperClassNames, renderIcon } from '../../utils'

const removeImage = (e, uploadInstructions) => {
  e.stopPropagation()
  uploadInstructions('')
}

const handleAssetSelect = (e, previewSrc, setSelectedAsset) => {
  e.stopPropagation()
  setSelectedAsset(previewSrc)
}

const ImagePreview = ({
  fileName,
  previewSrc,
  uploadInstructions,
  selected,
  setSelectedAsset,
}) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  <Fragment>
    <div
      className={kuiperClassNames('preview-image-wrapper')}
      onClick={(e) => handleAssetSelect(e, previewSrc, setSelectedAsset)}
    >
      <img
        className={kuiperClassNames(`${selected && 'selected'}`)}
        src={previewSrc}
        alt={fileName}
        title={fileName}
      />
      {selected &&
        renderIcon('checkmark', {
          style: { height: 10, width: 14, color: 'white' },
          ariaLabel: 'Selected',
          ariaMode: 'presentational',
        })}
    </div>
    <div className={kuiperClassNames('text')}>
      <div className={kuiperClassNames('file-name')}>{fileName}</div>
      <Button
        onClick={(e) => removeImage(e, uploadInstructions)}
        className={kuiperClassNames('remove')}
        label="Remove Image"
        type="secondary"
        position="left"
      />
    </div>
  </Fragment>
)

ImagePreview.propTypes = {
  fileName: string,
  previewSrc: string,
  selected: bool,
  setSelectedAsset: func,
  uploadInstructions: func,
}

export default ImagePreview
